export const isLoading = "request";
export const isError = "failure";
export const Login_Success = "auth_success";
export const Register_Success = "register_success";
export const User_Data_Success = "user_data_success";
export const User_Logout = "user_logout";